
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface TenderStatusSelectProps {
  status: string;
  onStatusChange: (value: string) => void;
  onClick: (e: React.MouseEvent) => void;
}

export const TenderStatusSelect = ({ status, onStatusChange, onClick }: TenderStatusSelectProps) => {
  const { t } = useTranslation();
  
  const getStatusColor = (status: string) => {
    switch (status) {
      case "not_started":
        return "bg-red-500 text-white hover:bg-red-600";
      case "in_process":
        return "bg-yellow-500 text-gray-900 hover:bg-yellow-600";
      case "bid":
        return "bg-green-500 text-white hover:bg-green-600";
      default:
        return "bg-red-500 text-white hover:bg-red-600";
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case "not_started":
        return t('dashboard.statusSelect.notStarted');
      case "in_process":
        return t('dashboard.statusSelect.inProcess');
      case "bid":
        return t('dashboard.statusSelect.bid');
      default:
        return t('dashboard.statusSelect.select');
    }
  };

  return (
    <Select
      value={status}
      onValueChange={onStatusChange}
    >
      <SelectTrigger 
        className={cn(
          "w-[180px] bg-white", // Removed dark mode classes
          getStatusColor(status)
        )}
        onClick={onClick}
      >
        <SelectValue placeholder={t('dashboard.statusSelect.select')}>
          {getStatusLabel(status)}
        </SelectValue>
      </SelectTrigger>
      <SelectContent 
        className="bg-white border" // Removed dark mode classes
      > 
        <SelectItem value="not_started">{t('dashboard.statusSelect.notStarted')}</SelectItem>
        <SelectItem value="in_process">{t('dashboard.statusSelect.inProcess')}</SelectItem>
        <SelectItem value="bid">{t('dashboard.statusSelect.bid')}</SelectItem>
      </SelectContent>
    </Select>
  );
};
